import script from "./FranchiseMenuControls.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseMenuControls.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import FranchiseMenuEnableModal from "@/components/franchise/FranchiseMenuEnableModal.vue";
import NeueToggle from "@/components/neue/NeueToggle.vue";
import WizardConfirmModal from "@/components/neue/wizard/WizardConfirmModal.vue";
script.components = Object.assign({}, { FranchiseMenuEnableModal, NeueToggle, WizardConfirmModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { FranchiseMenuEnableModal, NeueToggle, WizardConfirmModal }, script.__o.components);}